import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationType } from './domain';

@Injectable()
export class AppSettings {
	private _apiUrl = '';
	private _loginUrl = '';
	private _enableConsoleLogging: boolean = false;
	private _googleAnalyticsId = '';
	private _WFATenantId = '';
	private _WFAClientId = '';
	private _WFAAuthority = '';
	private _WFARedirectUri = '';
	private _OktaIssuer = '';
	private _OktaClientId = '';
	private _OktaRedirectUri = '';
	private _authProviders: Map<AuthenticationType, boolean>;

	public get APIURL()  : string { return this._apiUrl;   }
	public get loginURL(): string { return this._loginUrl; }
	public get enableConsoleLogging(): boolean { return this._enableConsoleLogging; }
	public get googleAnalyticsId(): string { return this._googleAnalyticsId; }
	public get WFATenantId()  : string { return this._WFATenantId;   }
	public get WFAClientId()  : string { return this._WFAClientId;   }
	public get WFAAuthority()  : string { return this._WFAAuthority;   }
	public get WFARedirectUri()  : string { return this._WFARedirectUri;   }
	public get OktaIssuer() : string { return this._OktaIssuer}
	public get OktaClientId() : string {return this._OktaClientId}
	public get OktaRedirectUri() : string {return this._OktaRedirectUri}
	public get authProviders(): Map<AuthenticationType, boolean> {return this._authProviders;}

	public APIURLOf(path: string): string {
		return this.APIURL + path;
	}

	constructor(private http: HttpClient){ }

	public getSettings() {
		if(this._apiUrl == '') {
			this.init();
		}
		return this;
	}

	public init(): Promise<null> {
		
		//Adding version to prevent browser caching of config files
		const version = new Date().getTime();

		const baseConfigPath = `/assets/appsettings.json?v=${version}`;
		const localConfigPath = `/assets/appsettings.local.json?v=${version}`;

		// Load base config from appsettings.json
		return <Promise<null>>firstValueFrom(this.http.get(baseConfigPath).pipe(
			map(json => <any>json)))
			.then(baseConfig => {
				// Try to load local overrides (silently fail if not found)
				return firstValueFrom(this.http.get(localConfigPath).pipe(
					map(json => <any>json)))
					.then(localConfig => {
						console.log("local config loaded:", localConfig);
						// Merge local config over base config
						const mergedConfig = { ...baseConfig, ...localConfig };
						this.applyConfig(mergedConfig);
					})
					.catch(() => {
						console.warn("No local config found, using base config only.");
						// If local config doesn't exist, just use base config
						this.applyConfig(baseConfig);
					});
			});
	}

	private applyConfig(config: any): void {
		console.log("Applying configuration:", config);
		this._loginUrl = config.loginURL || '';
		this._apiUrl = config.APIURL || '';
		this._enableConsoleLogging = config.enableConsoleLogging || false;
		this._googleAnalyticsId = config.googleAnalyticsId || '';
		this._WFATenantId = config.WFATenantId || '';
		this._WFAClientId = config.WFAClientId || '';
		this._WFAAuthority = config.WFAAuthority || '';
		this._WFARedirectUri = config.WFARedirectUri || '';
		this._OktaIssuer = config.OktaIssuer || '';
		this._OktaClientId = config.OktaClientId || '';
		this._OktaRedirectUri = config.OktaRedirectUri || '';
		this._authProviders = config.authProviders;
	}
}
